<template>
    <div class="page-content">
        <h3 class="title ml-3">Billing</h3>
        <span style="opacity: 50%;">Manage your plans and history here.</span>

        <div class="row stepper">
            <div class="col-12 col-md-2">
                <button class="btn" :class="{ 'active-tab': activeTab === 'overview' }"
                    @click="activeTab = 'overview'">Overview</button>
            </div>
            <div class="col-12 col-md-2" v-if="!isEnterprise">
                <button class="btn" :class="{ 'active-tab': activeTab === 'plans' }"
                    @click="activeTab = 'plans'">Plans</button>
            </div>
            <div class="col-12 col-md-2" v-if="!isEnterprise && !isFreeTrial">
                <button class="btn" :class="{ 'active-tab': activeTab === 'addons' }"
                    @click="activeTab = 'addons'">Add-ons</button>
            </div>
            <div class="col-12 col-md-2">
                <button class="btn" :class="{ 'active-tab': activeTab === 'preferences' }"
                    @click="activeTab = 'preferences'">Preferences</button>
            </div>
            <div class="col-12 col-md-2" v-if="!isFreeTrial">
                <button class="btn" :class="{ 'active-tab': activeTab === 'paymenthistory' }"
                    @click="activeTab = 'paymenthistory'">Payment History</button>
            </div>
        </div>
        <hr class="stepper-line">
        <div>
            <OverviewContent v-if="activeTab === 'overview'" @change-tab="handleTabChange" />
            <BillingPlan v-if="activeTab === 'plans'" />
            <AddOnsContent v-if="activeTab === 'addons'" />
            <PaymentHistoryContent v-if="activeTab === 'paymenthistory'" />
            <PreferencesContent v-if="activeTab === 'preferences'" />
        </div>
    </div>
</template>

<script>
import OverviewContent from './OverviewContent.vue';
import AddOnsContent from './AddOnsContent.vue';
import PaymentHistoryContent from './PaymentHistoryContent.vue';
import PreferencesContent from './PreferencesContent.vue';
import BillingPlan from '../../components/settings/BillingPlans.vue';
import { mapState } from "vuex";

export default {
    name: "BillingSettings",
    components: {
        OverviewContent,
        AddOnsContent,
        PaymentHistoryContent,
        PreferencesContent,
        BillingPlan
    },
    data() {
        return {
            activeTab: 'overview',
            isEnterprise: false,
            isFreeTrial: false,
        };
    },
    methods: {
        handleTabChange(tab) {
            this.activeTab = tab;
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    mounted() {
        if (this.user.isEnterprise == true) this.isEnterprise = true
        else{          
            var billing = JSON.parse(localStorage.getItem('billingData'));
            this.isFreeTrial = billing.object.data.plan.planName === 'Free Trial' ? true  : false;
        }
    }
}
</script>

<style scoped>
.stepper {
    margin-top: 30px;
    display: flex;
    width: fit-content;
    gap: 0;
    margin-left: 2rem;
}

.stepper .col-12.col-md-2 {
    padding: 0;
    width: auto;
    flex: none;
}

.stepper .btn {
    background: transparent;
    color: #999999;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 400;
    border-radius: 0;
    white-space: nowrap;
    border-bottom: 2px solid #d6d4d4 !important;
    transition: all 0.2s ease;
}

.stepper .active-tab {
    background: #d1c9ff !important;
    color: #4B2EEE !important;
    border-bottom: 2px solid #6366F1 !important;
    font-weight: bold !important;
}

.stepper-line {
    display: none;
}

.title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}
</style>